/*************************************************/
/* ACCORDION                                     */
/*************************************************/
import customEventsNames from './../customEventsNames';
export function accordion() {
    const accordionParentSelector = '.accordion';
    const accordionItemSelector = '.accordion__item';
    const accordionItemToggleSelector = '.accordion__item-head';
    const accordionItemContentSelector = '.accordion__item-content';
    const accordionItemActiveClass = 'accordion__item--active';
    const accordionIdDataAttributeName = 'data-accordion-id';
    const accordionItemIdDataAttributeName = 'data-accordion-item-id';
    // The image accordion and the application image drive their media and text
    // panels the same way, so both blocks are matched here.
    const accordionImagesSelector = '.image-accordion, .application-image';
    const accordionImagesContainerSelector = '.image-accordion__media-container, .application-image__media-container';
    const accordionTextPanelsContainerSelector = '.image-accordion__text-panels, .application-image__text-panels';

    const getTargetedAccordion = (event) => {
        if (event != null) {
            return document.querySelector(
                `[${accordionIdDataAttributeName}="${event.detail.accordionId}"]`);
        }
    };
    const getTargetedAccordionItem = (event) => {
        if (event != null) {
            const targetedAccordion = getTargetedAccordion(event);
            if (targetedAccordion != null) {
                return targetedAccordion.querySelector(
                    `[${accordionItemIdDataAttributeName}="${event.detail.accordionItemId}"]`
                );
            }
        };
    }

    const setActiveStylesOnAccordionItem = (accordionItem) => {
        if (accordionItem != null) {
            const accordionItemContent = accordionItem.querySelector(accordionItemContentSelector);
            if (accordionItemContent) {
                accordionItemContent.style.maxHeight = `${accordionItemContent.scrollHeight}px`;
                accordionItemContent.setAttribute('aria-hidden', false);
            }
            accordionItem.classList.add(accordionItemActiveClass);
            accordionItem.setAttribute('aria-expanded', true);
        }
    };

    const setInactiveStylesOnAccordionItem = (accordionItem) => {
        if (accordionItem != null) {
            const accordionItemContent = accordionItem.querySelector(accordionItemContentSelector);
            if (accordionItemContent) {
                accordionItemContent.style.maxHeight = "0px";
                accordionItemContent.setAttribute('aria-hidden', true);
            }
            accordionItem.classList.remove(accordionItemActiveClass);
            accordionItem.setAttribute('aria-expanded', false);
        }
    };

    const init = () => {
        const accordions = document.querySelectorAll(accordionParentSelector);
        if (accordions != null && accordions.length > 0) {
            accordions.forEach(accordion => {
                accordion.addEventListener(customEventsNames.accordionActivateItemEventName, e => {
                    const targetedAccordionItem = getTargetedAccordionItem(e);
                    if (targetedAccordionItem) {
                        const deactivateAllItemsEvent = new CustomEvent(customEventsNames.accordionDeactivateAllItemsEventName, {
                            detail: {
                                accordionId: e.detail.accordionId
                            }
                        });
                        accordion.dispatchEvent(deactivateAllItemsEvent);
                    }

                    if (targetedAccordionItem != null) {
                        setActiveStylesOnAccordionItem(targetedAccordionItem);
                    }
                });

                accordion.addEventListener(customEventsNames.accordionDeactivateItemEventName, e => {
                    const targetedAccordionItem = getTargetedAccordionItem(e);
                    if (targetedAccordionItem != null) {
                        setInactiveStylesOnAccordionItem(targetedAccordionItem);
                    }
                });

                accordion.addEventListener(customEventsNames.accordionDeactivateAllItemsEventName, e => {
                    const targetedAccordion = getTargetedAccordion(e);
                    if (targetedAccordion != null) {
                        targetedAccordion.querySelectorAll(accordionItemSelector).forEach(accordionItem => {
                            setInactiveStylesOnAccordionItem(accordionItem);
                        });
                    }
                });

                accordion.querySelectorAll(accordionItemToggleSelector).forEach(accordionItem => {
                    accordionItem.addEventListener('click', e => {
                        const clickedAccordionItem = e.target.closest(accordionItemSelector);
                        const itemId = clickedAccordionItem.dataset.accordionItemId;
                        const itemIndex = clickedAccordionItem.dataset.accordionItemIndex;
                        const accordionParent = e.target.closest(accordionParentSelector);
                        const accordionId = accordionParent.dataset.accordionId;

                        if (clickedAccordionItem.classList.contains(accordionItemActiveClass)) {
                            const deactiveAccordionItemEvent = new CustomEvent(customEventsNames.accordionDeactivateItemEventName, {
                                detail: {
                                    accordionId: accordionId,
                                    accordionItemId: itemId,
                                }
                            });
                            accordionParent.dispatchEvent(deactiveAccordionItemEvent);
                        } else {
                            const activateAccordionItemEvent = new CustomEvent(customEventsNames.accordionActivateItemEventName, {
                                detail: {
                                    accordionId: accordionId,
                                    accordionItemId: itemId,
                                    accordionItemIndex: itemIndex,
                                }
                            });
                            accordionParent.dispatchEvent(activateAccordionItemEvent);

                            const accordionImagesParent = clickedAccordionItem.closest(accordionImagesSelector);
                            if (accordionImagesParent) {
                                accordionImagesParent.querySelector(accordionImagesContainerSelector).dispatchEvent(activateAccordionItemEvent);
                                const textPanelsContainer = accordionImagesParent.querySelector(accordionTextPanelsContainerSelector);
                                if (textPanelsContainer) {
                                    textPanelsContainer.dispatchEvent(activateAccordionItemEvent);
                                }
                            }
                        }
                    });
                });

                // Initially set the height of the first active item
                setActiveStylesOnAccordionItem(accordion.querySelector(`.${accordionItemActiveClass}`));

                const accordionInitialized = new CustomEvent(customEventsNames.accordionInitialised, {});
                accordion.dispatchEvent(accordionInitialized);

            });
        }
    };

    init();
}

export function accordionTextPanels() {

    const textPanelsContainerSelector = ".image-accordion__text-panels, .application-image__text-panels";
    const textPanelSelector = ".accordion__text-panel";
    const textPanelActiveClass = "accordion__text-panel--active";

    const init = () => {
        const panelContainers = document.querySelectorAll(textPanelsContainerSelector);
        if (panelContainers) {
            panelContainers.forEach(container => {
                container.addEventListener(customEventsNames.accordionActivateItemEventName, e => {
                    container.querySelectorAll(textPanelSelector).forEach((panel, i) => {
                        if (i == e.detail.accordionItemIndex) {
                            panel.classList.add(textPanelActiveClass);
                        } else {
                            panel.classList.remove(textPanelActiveClass);
                        }
                    });
                });
            });
        }
    };

    init();
}

export function accordionImages() {

    const accordionImagesContainerSelector = ".image-accordion__media-container, .application-image__media-container";
    const accordionImageSelector = ".image-accordion__media, .application-image__media";
    const defaultItemIndex = 1; // The index of the default item

    // Each block keeps its own prefix, so the modifiers are built from the media
    // element's own base class rather than hardcoded to one component.
    const baseClass = (image) => [...image.classList].find(name => name.endsWith('__media'));
    const activeClass = (image) => `${baseClass(image)}--active`;
    const isFallback = (image) => image.classList.contains(`${baseClass(image)}--fallback`);

    const init = () => {
        const imageContainers = document.querySelectorAll(accordionImagesContainerSelector);
        if (imageContainers) {
            imageContainers.forEach(container => {

                // Select both the default and fallback images
                const images = container.querySelectorAll(accordionImageSelector);

                // Only a component with a fallback has one to deactivate — without
                // it images[0] is the first item, which must stay active.
                if (images.length > defaultItemIndex
                    && isFallback(images[0])
                    && images[defaultItemIndex].classList.contains(activeClass(images[defaultItemIndex]))) {
                    images[0].classList.remove(activeClass(images[0]));
                }

                container.addEventListener(customEventsNames.accordionActivateItemEventName, e => {
                    let i = 0;
                    container.querySelectorAll(accordionImageSelector).forEach(image => {
                        image.classList.remove(activeClass(image));
                        if (isFallback(image)) return;
                        if (i == e.detail.accordionItemIndex) {
                            image.classList.add(activeClass(image));
                        }
                        i++;
                    });
                });
            });
        }
    };

    init();
}